import styled from 'styled-components';

export const Container = styled.div`
  width: 95%;
  margin-left: 5%;
`;

// Main content styles
export const MainContent = styled.div`
  flex: 1;
  overflow: auto;
  background-color: #fcf7f5;
`;

export const ContentWrapper = styled.div`
  max-width: 1600px;
  margin: 0 auto;
  padding: 40px 32px;
`;

// Header styles
export const HeaderSection = styled.div`
  margin-bottom: 40px;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const HeaderTextContainer = styled.div``;

export const PageTitle = styled.h1`
  font-size: 2.25rem;
  text-transform: uppercase;
  color: #111827;
  margin-bottom: 12px;
  font-weight: 300;
  font-family: 'Oswald', sans-serif;
  margin: 0 0 12px 0;
`;

export const PageSubtitle = styled.p`
  font-size: 1.125rem;
  color: #4b5563;
  max-width: 720px;
  margin: 0;
`;

export const NoOrganizationDesc = styled.p`
font-size: 1.125rem;
  color: #4b5563;
  max-width: 720px;
  margin: 0;`

// Card styles
export const CardContainer = styled.div`
  background: white;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  padding: 24px;
  margin-bottom: 24px;
`;

export const OrganizationCard = styled.div`
  background: white;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  padding: 24px;
  transition: box-shadow 0.3s;
  
  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const CardTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px 0;
`;

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardMetaText = styled.span`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const CardMetaDivider = styled.span`
  color: #d1d5db;
`;

// Status badge
export const StatusBadge = styled.span`
  font-size: 0.75rem;
  padding: 4px 10px;
  border-radius: 9999px;
  font-weight: 500;
  background-color: ${props => props.$isActive ? '#dcfce7' : '#f3f4f6'};
  color: ${props => props.$isActive ? '#15803d' : '#4b5563'};
`;

// Usage statistics
export const UsageStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

export const UsageStatItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-radius: 8px;
  background-color: ${props => props.$bgColor || '#eff6ff'};
`;

export const UsageStatLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UsageStatLabel = styled.span`
  font-size: 0.875rem;
  color: #374151;
`;

export const UsageStatValue = styled.span`
  font-weight: 600;
  color: #111827;
`;

// Card actions
export const CardActions = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f6;
`;

// Button styles
export const PrimaryButton = styled.button`
  padding: 14px 24px;
  background-color: #f9df25;
  color: black;
  border-radius: 12px;
  transition: all 0.3s;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  min-width: 214px;
  
  &:hover {
    opacity: 0.9;
  }

  &.disabled {
    background-color: #d0d0d0;
    color: #7a7a7a;
    cursor: not-allowed !important;
  }
`;

export const SecondaryButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  background-color: ${props => props.disabled ? 'gray' : 'black'};
  color: white;
  border-radius: 8px;
  transition: background-color 0.3s;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  font-size: 0.875rem;
  cursor: ${props => (props.disabled ? 'no-drop' : 'pointer')};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  
  &:hover {
    background-color: #1f2937;
  }
`;

export const DangerButton = styled.button`
  padding: 10px 16px;
  background-color: #f3f4f6;
  color: #dc2626;
  border-radius: 8px;
  transition: background-color 0.3s;
  border: none;
  font-size: 0.875rem;
  cursor: ${props => (props.disabled ? 'no-drop' : 'pointer')};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
  
  &:hover {
    background-color: #fef2f2;
  }
`;

export const ActionButton = styled.button`
  flex: 1;
  padding: 10px 16px;
  background-color: ${props => props.disabled ? '#f3e059' : '#f9df25'};
  color: black;
  border-radius: 8px;
  transition: colors 0.3s;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
  cursor: ${props => (props.disabled ? 'no-drop' : 'pointer')};
  opacity: ${props => (props.disabled ? '0.5' : '1')};
`;

// Grid styles
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;


// Results count
export const ResultsCount = styled.p`
  font-size: 0.875rem;
  color: #4b5563;
  margin-bottom: 16px;
`;

export const ResultsCountNumber = styled.span`
  font-weight: 600;
  color: #111827;
`;

// Search and filter styles
export const SearchFilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  @media (min-width: 1024px) {
    flex-direction: row;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 1;
  position: relative;
`;

// Modal styles
export const ModalHeader = styled.div`
  background-color: #18012f;
  padding: 40px 32px;
  color: white;
`;

export const ModalHeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
`;

export const ModalIcon = styled.div`
  width: 56px;
  height: 56px;
  background-color: #f9df25;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
`;

export const ModalTitle = styled.h2`
  font-size: 1.875rem;
  font-weight: 300;
  text-transform: uppercase;
  color: white;
  margin: 0;
  font-family: 'Oswald', sans-serif;
`;

export const ModalSubtitle = styled.p`
  color: #d1d5db;
  font-size: 0.875rem;
  margin: 4px 0 0 0;
`;

export const ModalBody = styled.div`
  padding: 32px;
  background-color: #fcf7f5;
`;

export const ModalFooter = styled.div`
  padding: 20px 32px;
  background-color: white;
  border-top: 1px solid #f3f4f6;
  display: flex;
  gap: 12px;
  flex-direction: row;
  justify-content: flex-end;
`;

export const FormField = styled.div`
  margin-bottom: 24px;
  .organization-type {
    .ant-select-selection--single {
        height: 48px !important;
        padding: 4px;
    }
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const LoaderContainer = styled.div`
    margin-top: 150px;
`

// Empty state styles
export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  background: white;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
`;

export const EmptyStateIcon = styled.div`
  width: 96px;
  height: 96px;
  background-color: #fcf7f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

export const EmptyStateTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px 0;
  font-family: 'Oswald', sans-serif;
  text-transform: uppercase;
`;

export const EmptyStateMessage = styled.p`
  font-size: 1rem;
  color: #6b7280;
  margin: 0 0 24px 0;
  text-align: center;
  max-width: 400px;
`;

export const EmptyStateSearchQuery = styled.span`
  font-weight: 600;
  color: #18012f;
`;

// Permissions styles
export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FeatureItem = styled.div`
  padding: 12px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s;
  
  &:hover {
    border-color: #f9df25;
    background-color: #fffef0;
  }
  
  .ant-checkbox-wrapper {
    width: 100%;
    display: flex;
    .ant-checkbox.ant-checkbox-checked {
      height: 16px;
    }
  }
`;

export const FeaturesLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #2563eb;
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  
  &:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }
`;

export const PermissionsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #2563eb;
  font-size: 0.875rem;
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  
  &:hover {
    color: #1d4ed8;
    text-decoration: underline;
  }
`;
